import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDStack } from '@facet-wealth/design';

const styles = (theme) => ({
  root: {},
  label: {
    margin: theme.spacing(2, 0),
    textAlign: 'center',
  },
});

const FacetPlanEmergencyFundStageInfoWizardLayout = () => {
  return (
    <FDStack direction={'column'} spacing={2}>
      <MetaControlField attr={'stageOneAmount'} />
      <MetaControlField attr={'stageThreeAmount'} />
      <MetaControlField attr={'numMonthsExpenses'} />
    </FDStack>
  );
};

FacetPlanEmergencyFundStageInfoWizardLayout.defaultProps = {
};

FacetPlanEmergencyFundStageInfoWizardLayout.propTypes = {
};

export default withStyles(styles)(FacetPlanEmergencyFundStageInfoWizardLayout);
